import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CashPaymentComponent } from './cash-payment/cash-payment.component';
import { DeferredPaymentComponent } from './deferred-payment/deferred-payment.component';
import { PaybackTableComponent } from './payback-table/payback-table.component';
import { PaymentDiscountComponent } from './payment-discount/payment-discount.component';
import { PaymentDocumentValueComponent } from './payment-document-value/payment-document-value.component';
import { PaymentLabelValueComponent } from './payment-label-value/payment-label-value.component';
import { PaymentTableComponent } from './payment-table/payment-table.component';
import { SalePaymentsComponent } from './sale-payments.component';
import { PeriodicitiesComponent } from './periodicities/periodicities.component';
import { PaymentAdditionComponent } from './payment-addition/payment-addition.component';

@NgModule({
  declarations: [
    SalePaymentsComponent,
    CashPaymentComponent,
    DeferredPaymentComponent,
    PaybackTableComponent,
    PaymentDiscountComponent,
    PaymentDocumentValueComponent,
    PaymentLabelValueComponent,
    PaymentTableComponent,
    PeriodicitiesComponent,
    PaymentAdditionComponent
  ],
  imports: [CommonModule, SharedModule]
})
export class SalePaymentsModule {}
